import { type FC } from 'react';
import { IconButton } from '@mui/material';
import { ChevronLeft, Check } from '@mui/icons-material';
import { type OmitDeep } from 'type-fest';

import { PageHeader, type PageHeaderProps } from './page-header';

export type FormPageHeaderProps = OmitDeep<
  PageHeaderProps,
  'navigationIcon'
> & {
  /**
   * Handler for app menu click
   */
  onNavigationIconClick: () => void;

  /**
   * Whether to show the save button
   */
  showSaveButton?: boolean;

  /**
   * Handler for save button click
   */
  onSaveButtonClick?: () => void;
};

export const FormPageHeader: FC<FormPageHeaderProps> = ({
  onNavigationIconClick,
  onSaveButtonClick,

  showSaveButton,

  children,

  ...props
}) => (
  <PageHeader
    navigationIcon={
      <IconButton
        color="inherit"
        aria-label="menu"
        onClick={onNavigationIconClick}
        edge="start"
        sx={{ mr: 0.5 }}>
        <ChevronLeft fontSize="large" />
      </IconButton>
    }
    {...props}>
    {children}
    {showSaveButton && (
      <IconButton
        color="inherit"
        aria-label="save"
        onClick={onSaveButtonClick}
        edge="start"
        sx={{ mr: 0.5 }}>
        <Check fontSize="large" />
      </IconButton>
    )}
  </PageHeader>
);
